import { Component, input, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-translations-ai-modal',
    templateUrl: './translations-ai-modal.component.html',
    styleUrl: './translations-ai-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class TranslationsAiModalComponent {

  @Input() originalText: string = '';
  @Input() translatedText: string = '';
  @Input() language: string = '';

  constructor(public activeModal: NgbActiveModal,) { }

  accept() {
    this.activeModal.close(this.translatedText);
  }
}
